import { useCallback, useEffect, useMemo, useState } from 'react';
import { Wrapper } from '../../style';
import { ActionWrapper, Box, FolderItem, FolderList, Header, Metas } from './style';
import Folder from './Folder';
import Table from './Table';
import FileRender from '../../../../components/FileRender';
import Rollback from '../../../../components/Rollback';
import { useNavigate } from 'react-router-dom';
import ChevronRightIcon from '../../../../assets/icons/chevron-right.svg?react';
import Button from '../../../../components/Button';
import Tooltip from '../../../../components/Tooltip';
import { DropZone } from '../../../../components/DropZone';
import { Tooltip as MantineTooltip } from '@mantine/core';
import { data, files, folders } from './mock';

const columns = [
  {
    name: 'File name',
    key: 'name',
    render: data => {
      return <FileRender name={data.name} type={data.type} />;
    }
  },
  {
    name: 'File type',
    key: 'type'
  },
  {
    name: 'File Size',
    key: 'size'
  },
  {
    name: 'Edited',
    key: 'edited_at'
  }
];

const SelectFiles = () => {
  const navigate = useNavigate();

  const [parentFolders, setParentFolders] = useState([]);
  const [coreSite, setCoreSite] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const lastParentFolder = useMemo(() => parentFolders[parentFolders.length - 1], [parentFolders]);

  useEffect(() => {
    if (parentFolders.length !== 0) return;

    clear();
  }, [parentFolders]);

  const selectCoreSite = site => {
    setCoreSite(site);
    addFolder(site);
  };

  const addFolder = item => {
    setParentFolders(prev => [...prev, item]);
  };

  const clear = () => {
    setCoreSite(null);
  };

  const goToFolder = f => {
    setParentFolders(prev => prev.filter((_, idx) => idx <= f));
  };

  const onSelectFiles = item => {
    const findFile = selectedFiles.find(file => file.name === item.name);

    if (findFile) setSelectedFiles(prev => prev.filter(file => file.name !== item.name));
    else setSelectedFiles(prev => [...prev, item]);
  };

  const onSelectAll = () =>
    setSelectedFiles(prev => (prev.length === folders.length ? [] : folders));

  const onClickFile = data => {
    if (data.type === 'folder') addFolder(data);
    else onSelectFiles(data);
  };

  const onClickBack = useCallback(() => {
    if (parentFolders.length === 0) navigate('../../');
    else setParentFolders(prev => prev.filter((_, f) => f !== prev.length - 1));
  }, [parentFolders]);

  // new extracted functions to replace inline events
  const handleUploadClick = useCallback(() => {
    navigate('../../report/123213');
  }, [navigate]);

  const handleHomeClick = useCallback(() => {
    goToFolder(-1);
  }, []);

  const handleFolderClick = useCallback(index => {
    goToFolder(index);
  }, []);

  const handleCoreSiteSelect = useCallback(site => {
    selectCoreSite(site);
  }, []);

  const handleFileDrop = useCallback(
    droppedFiles => {
      if (!droppedFiles || droppedFiles.length === 0) return;

      handleUploadClick();
    },
    [handleUploadClick]
  );

  return (
    <Wrapper>
      <Box>
        <Header>
          <Metas>
            <Rollback title="Back" onClick={onClickBack} />
            <div className="breadcrumb">
              <span onClick={handleHomeClick}>Uploading resources</span>{' '}
              {parentFolders.length > 0 && (
                <>
                  &nbsp; &nbsp;
                  <ChevronRightIcon />
                  &nbsp; &nbsp;
                </>
              )}
              {parentFolders.map((folder, f) => (
                <>
                  <span
                    key={f}
                    className={f === parentFolders.length - 1 ? 'active' : ''}
                    onClick={() => handleFolderClick(f)}
                  >
                    {folder.name}
                  </span>
                  {f < parentFolders.length - 1 && (
                    <>
                      &nbsp; &nbsp;
                      <ChevronRightIcon />
                      &nbsp; &nbsp;
                    </>
                  )}
                </>
              ))}
            </div>
            <h1>Choose Upload Resources</h1>
          </Metas>
          <ActionWrapper>
            <MantineTooltip
              label="Select files from the list or drag and drop files"
              disabled={selectedFiles.length > 0}
            >
              <div>
                <DropZone
                  onDrop={handleFileDrop}
                  variant="compact"
                  disabled={selectedFiles.length === 0}
                >
                  <Button disabled={selectedFiles.length === 0} onClick={handleUploadClick}>
                    Upload
                  </Button>
                </DropZone>
              </div>
            </MantineTooltip>
          </ActionWrapper>
        </Header>

        <FolderList>
          {coreSite && parentFolders.length === 1 && (
            <FolderItem>
              <Folder name={coreSite.name} description={coreSite.description} />
            </FolderItem>
          )}

          {!coreSite &&
            data.map((folder, f) => (
              <FolderItem key={f}>
                <Folder
                  name={folder.name}
                  description={folder.description}
                  onClick={() => handleCoreSiteSelect(folder)}
                />
              </FolderItem>
            ))}
        </FolderList>

        <Tooltip id="file-name" />

        {!!lastParentFolder && (
          <Table
            columns={columns}
            data={parentFolders.length > 1 ? files : folders}
            selectedFiles={selectedFiles}
            onSelectFile={onSelectFiles}
            onSelectAll={onSelectAll}
            onClickFile={onClickFile}
          />
        )}
      </Box>
    </Wrapper>
  );
};

export default SelectFiles;
